// extracted by css-extract-rspack-plugin
export default {"container":"src-domain-components-sync-configuration-button-SyncConfigurationButton-module__container-zjcICL","actions__container":"src-domain-components-sync-configuration-button-SyncConfigurationButton-module__actions__container-ZVsB0U","actionsContainer":"src-domain-components-sync-configuration-button-SyncConfigurationButton-module__actions__container-ZVsB0U"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"container\":\"src-domain-components-sync-configuration-button-SyncConfigurationButton-module__container-zjcICL\",\"actions__container\":\"src-domain-components-sync-configuration-button-SyncConfigurationButton-module__actions__container-ZVsB0U\",\"actionsContainer\":\"src-domain-components-sync-configuration-button-SyncConfigurationButton-module__actions__container-ZVsB0U\"}";
        // 1793705032913
        var cssReload = require("../../../../../node_modules/@rspack/core/dist/cssExtractHmr.js").cssReload(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  